// extracted by mini-css-extract-plugin
export default {"root":"SwLs9i"};